import { BrokerFormData } from '@/app/[locale]/(leads-forms)/brokers/inquiry/_components/types';
import { LandlordFormData } from '@/app/[locale]/(leads-forms)/landlords/inquiry/_components/types';
import { ApplicationFormData } from '@/app/[locale]/(leads-forms)/location-form/_components/types';
import { MeetingEventSpaceInquiryFormData } from '@/app/[locale]/(leads-forms)/meeting-event-space-inquiry/_components/types';
import {
  COOKIE_KEY_MKTO_REFERRER,
  getCookieByKey,
  getTrackingCookies,
} from '@/utils/cookies';
import { getLastIndustriousUrl } from '@/utils/routes';

import { formNames } from '../forms/types';
import { SimpleIndustriousLocationSearchDto } from '../locations/dto/simple-location-search.dto';
import {
  BrokerApplicationLeadDto,
  LandlordApplicationLeadDto,
  LocationApplicationLeadDto,
  MeetingEventSpaceInquiryLeadDto,
} from './dto';
import { WithTrackingDto } from './dto/withTracking.dto';

export const LANDLORD_INQUIRY_CAMPAIGN_ID = '18580';
export const BROKER_INQUIRY_CAMPAIGN_ID = '18573';

export function createLandlordLeadDto({
  address,
  ...otherFields
}: LandlordFormData): WithTrackingDto<LandlordApplicationLeadDto> {
  return {
    formName: formNames.LANDLORD,
    marketocampaignID: LANDLORD_INQUIRY_CAMPAIGN_ID,
    buildingAddress: address,
    ...otherFields,
    ...getTracking(),
  };
}

export function createMeetingLeadDto(
  form: MeetingEventSpaceInquiryFormData
): WithTrackingDto<MeetingEventSpaceInquiryLeadDto> {
  return {
    formName: formNames.MEETING_SPACE_REQUEST,
    ...form,
    ...getTracking(),
  };
}

export function createLocationApplicationLeadDto({
  phone,
  ...otherFields
}: ApplicationFormData): WithTrackingDto<LocationApplicationLeadDto> {
  return {
    formName: formNames.LOCATION_APPLICATION,
    telephone: phone,
    ...otherFields,
    ...getTracking(),
  };
}

export function createBrokerLeadDto({
  phone,
  ...otherFields
}: BrokerFormData): WithTrackingDto<BrokerApplicationLeadDto> {
  return {
    formName: formNames.BROKER,
    marketocampaignID: BROKER_INQUIRY_CAMPAIGN_ID,
    telephone: phone,
    ...otherFields,
    ...getTracking(),
  };
}

export function getTracking(): WithTrackingDto<unknown> {
  const {
    marketoCookie,
    hubspotutk,
    utmCampaign,
    utmContent,
    utmMedium,
    utmSource,
    utmTerm,
    indChannel,
    indKpi,
    indAdGroup,
    indAdCampaign,
    indLs,
    indAud,
    gclid,
  } = getTrackingCookies();

  return {
    lastIndustriousUrl: getLastIndustriousUrl(),
    lastExternalUrl: getCookieByKey(COOKIE_KEY_MKTO_REFERRER) ?? null, // to remove after marketo is removed
    gclid: gclid ?? null,
    utms: {
      campaign: utmCampaign ?? null,
      source: utmSource ?? null,
      medium: utmMedium ?? null,
      content: utmContent ?? null,
      term: utmTerm ?? null,
    },
    marketoCookie: marketoCookie ?? null,
    hubspotutk: hubspotutk ?? null,
    channel: indChannel ?? null,
    kpi: indKpi ?? null,
    adGroup: indAdGroup ?? null,
    adCampaign: indAdCampaign ?? null,
    ls: indLs ?? null,
    aud: indAud ?? null,
  };
}

export function isCalendlyPreLoadable(form: {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  phone: string;
  location?: SimpleIndustriousLocationSearchDto | string;
}): boolean {
  return !!(
    form.company &&
    form.email &&
    form.firstName &&
    form.lastName &&
    form.location &&
    form.phone
  );
}
